import React from 'react';
import { motion } from 'framer-motion';
import styles from './OrdersPage.module.css';

export function StatusBadge({ label, color, bgColor, pulsing }: {
  label: string;
  color: string;
  bgColor: string;
  pulsing?: boolean;
}): React.JSX.Element {
  return (
    <span
      className={styles.statusBadge}
      style={{ color, background: bgColor }}
    >
      {pulsing && (
        <motion.span
          animate={{ opacity: [1, 0.3, 1] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className={styles.pulsingDot}
          style={{ background: color }}
        />
      )}
      {label}
    </span>
  );
}

export function SectionDot({ color, pulsing }: { color: string; pulsing?: boolean }): React.JSX.Element {
  if (pulsing) {
    return (
      <motion.span
        animate={{ opacity: [1, 0.4, 1] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className={styles.sectionDot}
        style={{ background: color }}
      />
    );
  }
  return (
    <span
      className={styles.sectionDot}
      style={{ background: color }}
    />
  );
}
